module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Part-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "bodymatter part",
      "id": "part001"
    }
  }, [_c('div', {
    staticClass: "ext_chp"
  }, [_c('div', {
    staticClass: "width-10"
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Art_Ptorn.jpg"
    }
  })])])]), _vm._v(" "), _c('h1', {
    staticClass: "part-number"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-part001"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "ext_cha"
  }, [_c('div', {
    staticClass: "decoration-rw10"
  }, [_c('div', {
    staticClass: "media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw"
  }, [_c('div', {
    staticClass: "pc-rw"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Art_line.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Death is the Physician of the Poor")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_c('em', [_vm._v("Liagh gach boicht bas")])]), _vm._v(" "), _c('div', {
    staticClass: "ext_chb"
  }, [_c('div', {
    staticClass: "decoration-rw10"
  }, [_c('div', {
    staticClass: "media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw"
  }, [_c('div', {
    staticClass: "pc-rw"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Art_line1.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("1825")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cb37348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part001.vue
// module id = 81
// module chunks = 0